import { Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { Subject } from "rxjs";
import { environment } from "../../../../../src/environments/environment";

@Injectable({ providedIn: "root" })
export class SignalrService {
  private hubConnection!: signalR.HubConnection;

  startConnection(userKey: string): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.baseApiUrl + `/signalr?userKey=${userKey}`, {
        withCredentials: true,
      })
      .withAutomaticReconnect([
        0, 2000, 10000, 30000, 30000, 30000, 30000, 30000,
      ])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.hubConnection
      .start()
      .then(() => console.log("Connection started", this.hubConnection.state))
      .catch((err) => {
        console.error("Error while starting connection: " + err);
        this.forceReconnect();
      });
  }

  private forceReconnect() {
    if (this.hubConnection.state == signalR.HubConnectionState.Disconnected) {
      console.info("Trying to reconnect to the server signalR in 60 seconds");
      setTimeout(() => {
        this.hubConnection
          .start()
          .then(() => console.log("Connection started"))
          .catch((err) => {
            console.error("Error while starting connection: " + err);
            this.forceReconnect();
          });
      }, 60000);
    }
  }

  onNotification(callback: (message: string) => void): void {
    this.hubConnection.on("ReceiveNotification", callback);
  }

  public stopConnection() {
    if (
      this.hubConnection &&
      this.hubConnection.state == signalR.HubConnectionState.Connected
    )
      this.hubConnection.stop();
  }
}
